import { AnyAction } from "redux";
import { IUserInfoState } from "..";
import { types } from "../../actions";
import { NotificationGroup, UserInfoModel, UserNotifGroups, UserPreferences } from "../states/user-info";
import { JogId } from "../states/agency";
import { GetJog } from "../states/agency/jogs";

export const initialUserState: IUserInfoState = {
  allReadyOpGroups: [] as NotificationGroup[],
  currentUserInfo: {} as UserInfoModel,
  userInfo: {} as UserInfoModel,
  userPreferences: {} as UserPreferences,
  userCache: [] as UserInfoModel[],
  userReadyOpGroups: [] as UserNotifGroups[],
  successMessage: "",
  failureMessage: "",
};

function userInfoReducer(
  state = initialUserState,
  action: AnyAction
): IUserInfoState {

  const isUserInCache = (): boolean => {
    // GET user returns empty objects when the user is not found, so if the email is an an empty string, return true to avoid adding the empty obj to cache.
    return !(action.payload.userInfo.email) || state.userCache.find((u) => u.email === action.payload.userInfo.email as string) !== undefined;
  }

  switch (action.type) {
    case types.GET_CURRENT_USER_INFO_SUCCESS:
      return {
        ...state,
        currentUserInfo: action.payload.userInfo,
        ...(!isUserInCache() && { userCache: [...state.userCache, action.payload.userInfo] }),
        successMessage: "",
        failureMessage: "",
      };
    case types.GET_CURRENT_USER_INFO_FAILURE:
      return {
        ...state,
        successMessage: "",
        failureMessage: action.payload.failureMessage,
      };
    case types.GET_USER_INFO_SUCCESS:
      return {
        ...state,
        userInfo: action.payload.userInfo,
        ...(!isUserInCache() && { userCache: [...state.userCache, action.payload.userInfo] }),
        successMessage: "",
        failureMessage: "",
      };
    case types.GET_USER_INFO_FAILURE:
      return {
        ...state,
        successMessage: "",
        failureMessage: action.payload.failureMessage,
      };
    case types.GET_ALL_READYOP_GROUPS_SUCCESS:
      return {
        ...state,
        allReadyOpGroups: action.payload.notifGroups,
        successMessage: "",
        failureMessage: "",
      };
    case types.GET_ALL_READYOP_GROUPS_FAILURE:
      return {
        ...state,
        successMessage: "",
        failureMessage: action.payload.failureMessage,
      };
    case types.GET_USER_READYOP_GROUPS_SUCCESS:
      return {
        ...state,
        userReadyOpGroups: action.payload.userNotifGroups,
        successMessage: "",
        failureMessage: "",
      };
    case types.GET_USER_READYOP_GROUPS_FAILURE:
      return {
        ...state,
        successMessage: "",
        failureMessage: action.payload.failureMessage,
      };
    case types.UPDATE_USER_READYOP_GROUPS_SUCCESS:
      return {
        ...state,
        successMessage: action.payload.successMessage,
        failureMessage: "",
      };
    case types.UPDATE_USER_READYOP_GROUPS_FAILURE:
      return {
        ...state,
        successMessage: "",
        failureMessage: action.payload.failureMessage,
      };
    case types.UPDATE_USER_PROFILE_SUCCESS:
      return {
        ...state,
        successMessage: action.payload.updateUserProfileSuccessMessage,
        failureMessage: "",
      };
    case types.UPDATE_USER_PROFILE_FAILURE:
      return {
        ...state,
        successMessage: "",
        failureMessage: action.payload.updateUserProfileFailureMessage,
      };
    case types.GET_USER_PREFERENCES_SUCCESS:
      // Default users to their own JogId, or "Seattle" if they have no jogFilters (IDs) in their User Preferences.
      // TODO: jcavner: Maybe move this into a saga instead of in the reducer.
      let prefs = action.payload.userPreferences as UserPreferences;
      if (!prefs.jogFilters.length) {
        let jogId = state.currentUserInfo.jogId || JogId.SeattleArea;
        prefs.jogFilters.push(jogId);

        // Populate agencyFilters with all agencies for their default JOG
        prefs.agencyFilters = [];
        const jog = GetJog(jogId);
        jog?.agencies.forEach((agency) => { if (agency.isFilter) prefs.agencyFilters.push(agency.id) });
      }

      return {
        ...state,
        userPreferences: prefs,
        successMessage: "",
        failureMessage: "",
      };
    case types.GET_USER_PREFERENCES_FAILURE:
      return {
        ...state,
        successMessage: "",
        failureMessage: action.payload.failureMessage,
      };
    case types.UPDATE_USER_PREFERENCES:
      // If user is specified, avoid updating prefs of current user. This supports setting prefs for invited user.
      // Could refactor to use a SET_INVITED_USER_PREFERENCES action instead, with no reducer handling.
      if(action.payload.userEmail) {
        return state;
      }

      return {
        ...state,
        userPreferences: action.payload.userPreferences
      }
    case types.UPDATE_USER_PREFERENCES_SUCCESS:
      return {
        ...state,
        successMessage: action.payload.successMessage,
        failureMessage: "",
      };
    case types.UPDATE_USER_PREFERENCES_FAILURE:
      return {
        ...state,
        successMessage: "",
        failureMessage: action.payload.failureMessage,
      };
    default:
      return state;
  }
}

export default userInfoReducer;
